export default __webpack_public_path__ + "static/media/Citadium.8e266a19.png";